import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=5907ea84"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5907ea84')) {
      api.createRecord('5907ea84', component.options)
    } else {
      api.reload('5907ea84', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=5907ea84", function () {
      api.rerender('5907ea84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/SystemManage/HomePage/Carousel.vue"
export default component.exports